import { crossEnv } from '../../setup/configureEnvironment';

export default ({ beforeRequest }) => {
  beforeRequest.push(({ headers }) => {
    if (crossEnv.TRANSACTION_ID) {
      headers.set('X-Transaction-ID', crossEnv.TRANSACTION_ID);
    }
  });
};
